import { useContext } from "react";
import { WeatherContext } from "../providers";

/**
 * Hook that returns the weather context value
 * 
 * @returns The weather context
 */
const useWeather = () => {
  const weatherContext = useContext(WeatherContext);

  if (!weatherContext) {
    throw new Error("useWeather must be used within an WeatherProvider");
  }
  return weatherContext;
};

export default useWeather;
